import type { ReactNode } from 'react';
import { Outlet } from 'react-router-dom';
import { Header } from './Header';

interface Props {
  /**
   * A full-width strip between the header and the page, on every page. The router passes the Compliance
   * console's open-P1 strip here in builds that have the console; it is a slot (not an import) so the
   * shared layout never depends on a feature.
   */
  banner?: ReactNode;
}

/** App frame: fixed header + optional banner strip + scrollable main content. */
export function AppShell({ banner = null }: Props) {
  return (
    <div className="flex h-screen w-screen flex-col overflow-hidden bg-canvas text-text">
      <Header />
      {banner}
      <main className="flex-1 overflow-y-auto px-4 py-6 sm:px-6">
        <div className="mx-auto w-full max-w-[1400px]">
          <Outlet />
        </div>
      </main>
    </div>
  );
}
